export const saveQueryAction = (payload) => {
    return {
        type: "saveQuery",
        payload
    }
}